import { useDataTable } from '../DataTable';

const ShowTotalFiles = () => {
  const { table } = useDataTable();

  return (
    <div>
      <h5 className="text-gray-800">Recentes</h5>
      <h6 className="text-gray-500">{table?.getRowCount()} arquivos na biblioteca</h6>
    </div>
  );
};

export default ShowTotalFiles;
